import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

import DateInput from "../../../../parts/inputs/date-input";
import NutritionHistoryTable from "./NutritionHistoryTable";
import { getDateToDisplay } from "../../../../utils/nutrition-helpers";
import CheckboxInput from "../../../../parts/checkbox-input";
import Dropdown from "../../../../parts/dropdown";

const NutritionHistory = ({
  dateFrom,
  dateTo,
  stats,
  averageStats,
  activeDayUtc,
  nutritionPlans,
  selectedPlan,
  handleDateChange,
  handleActiveDayChange,
  handleSelectedPlanChange,
  activeUser,
  isActiveDayPeriod,
  showAveragesOnly,
  handleShowAveragesOnly,
  activeExercises,
}) => {
  const { t } = useTranslation("athlete-portal");
  const { units } = activeUser;

  const completeStats = stats
    .concat(averageStats)
    .sort((a, b) => b.utcDate - a.utcDate);
  const getDropdownLabel = () => {
    return selectedPlan
      ? `${getDateToDisplay(selectedPlan.utcStartDate)} -
  ${getDateToDisplay(selectedPlan.utcEndDate)}`
      : nutritionPlans.length
        ? t("nutritionPage.history.selectAPlan")
        : t("nutritionPage.history.noPlansCreated");
  };
  return (
    <>
      <header>
        <hgroup>
          <label>{t("nutritionPage.history.selectPlan")}</label>
          <div>
            <Dropdown
              summaryText={getDropdownLabel()}
              options={nutritionPlans.map((plan) => {
                return {
                  text: `${getDateToDisplay(plan.utcStartDate)} -
                ${getDateToDisplay(plan.utcEndDate)}`,
                  value: plan._id,
                };
              })}
              onSelectFn={handleSelectedPlanChange}
            />
            <CheckboxInput
              inputName="showAverage"
              id="showAverageOnly"
              value="kcal"
              checked={showAveragesOnly}
              onChangeFn={handleShowAveragesOnly}
              labelText={t("nutritionPage.adherence.showAveragesOnly")}
            />
          </div>
        </hgroup>
        <hgroup className="mobile-hidden">
          <label>{t("nutritionPage.history.reportingPeriod")}</label>
          <div role="calendar-date-selectors">
            <DateInput
              name="from"
              placeholder={t("nutritionPage.history.startDate")}
              value={dateFrom}
              max={dateTo}
              onChange={(date) => handleDateChange(date, "dateFrom")}
            />
            <span>{t("nutritionPage.history.to")}</span>
            <DateInput
              name="to"
              placeholder={t("nutritionPage.history.endDate")}
              value={dateTo}
              min={dateFrom}
              onChange={(date) => handleDateChange(date, "dateTo")}
              alignRight={true}
            />
          </div>
        </hgroup>
      </header>
      <section className="nutrition-history">
        {completeStats.length ? (
          <NutritionHistoryTable
            units={units}
            nutritionHistory={showAveragesOnly ? averageStats : completeStats}
            activeDayUtc={activeDayUtc}
            handleActiveDayChange={handleActiveDayChange}
            isActiveDayPeriod={isActiveDayPeriod}
            nutritionPlans={nutritionPlans}
            activeExercises={activeExercises}
          />
        ) : (
          <div className="no-data">{t("nutritionPage.noDataToShow")}</div>
        )}
      </section>
    </>
  );
};

export default NutritionHistory;
